import { render, staticRenderFns } from "./insuranceprintledger.vue?vue&type=template&id=40a95a80"
import script from "./insuranceprintledger.vue?vue&type=script&lang=js"
export * from "./insuranceprintledger.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports